/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

export default {
  setToken: function (tokenObj) {
    localStorage.setItem('auth_data', JSON.stringify(tokenObj))
  },
  getAccessToken: function () {
    return JSON.parse(localStorage.getItem('auth_data'))
  },
  clearToken: function () {
    localStorage.removeItem('auth_data')
  },
  setDistrictSchool: function (tokenObj) {
    localStorage.setItem('ds_info', JSON.stringify(tokenObj))
  },
  getDistrictSchool: function () {
    return JSON.parse(localStorage.getItem('ds_info'))
  },
  clearDistrictSchool: function () {
    localStorage.removeItem('ds_info')
  },
  setAppState: function (state) {
    localStorage.setItem('appState', JSON.stringify({ ...this.getAppState(), ...state }))
  },
  getAppState: function () {
    return JSON.parse(localStorage.getItem('appState')) || {}
  },
  clearAppState: function () {
    localStorage.removeItem('appState')
  },
  setTourState: function (state) {
    localStorage.setItem('tourState', JSON.stringify({ ...this.getTourState(), ...state }))
  },
  setAnnouncements: function (data) {
    localStorage.setItem('student_announcements', JSON.stringify(data))
  },
  getAnnouncements: function () {
    return JSON.parse(localStorage.getItem('student_announcements'))
  },
  setParentAnnouncements: function (data) {
    localStorage.setItem('parent_announcements', JSON.stringify(data))
  },
  getParentAnnouncements: function () {
    return JSON.parse(localStorage.getItem('parent_announcements'))
  },
  getTourState: function () {
    return JSON.parse(localStorage.getItem('tourState')) || {}
  },
  clearTourState: function () {
    localStorage.setItem('tourState', JSON.stringify({}))
  },
  setSchoolSurveyToggled: function (data) {
    localStorage.setItem('schSurveyPopUp', JSON.stringify(data))
  },
  getSchoolSurveyToggled: function () {
    return JSON.parse(localStorage.getItem('schSurveyPopUp'))
  },
  setParentSchSurveyToggled: function (data) {
    localStorage.setItem('parentSchSurveyPopUp', JSON.stringify(data))
  },
  getParentSchSurveyToggled: function () {
    return JSON.parse(localStorage.getItem('parentSchSurveyPopUp'))
  },
  setMySurveyCount: function (data) {
    localStorage.setItem('mySurveyCount', JSON.stringify(data))
  },
  getMySurveyCount: function () {
    return JSON.parse(localStorage.getItem('mySurveyCount'))
  },
  setShowMandatoryOnlySurvey: function (data) {
    localStorage.setItem('showMandatoryOnlySurvey', JSON.stringify(data))
  },
  getShowMandatoryOnlySurvey: function () {
    return JSON.parse(localStorage.getItem('showMandatoryOnlySurvey'))
  },
}
